import {env} from './env-utils'

export const AppName = () => env.REACT_APP_THEME_NAME

export function getTitle(name?: string) {
  if (!name) return env.REACT_APP_THEME_NAME ?? ''
  return `${name} - ${env.REACT_APP_THEME_NAME}`
}

export const capitalizeWords = (str: string) => {
  if (!str) return ''
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
